import { Abide } from 'foundation-sites/js/foundation.abide.js';

export default class FoundationValidators {
    //@todo We need to consider how we want to handle custom validators and make them generic enough to work on all forms.
    //@todo This one was pulled from careers and needs to be here after the 6.4 Foundation upgrade.
    static addCustomerValidators() {
        Abide.defaults['validators']['checkbox_limit'] =
            function ($el, required, parent) {
                let group = parent.closest('.radio-group');
                let min = group.attr('data-abide-validator-min');
                let checked = group.find(':checked').length;
                if (checked >= min) {
                    group.find('span.radio-error').hide();
                    return true;
                } else {
                    group.find('span.radio-error').css({
                        display: 'block'
                    });
                    return false;
                }
            };
    }


}